import React, { Fragment } from 'react';

const PostSaleTo = () => (
  <Fragment>
    <h3 className="mt-5">Post Sale To:</h3>
    <p className="font-weight-bold mb-0">Invaluable</p>
    <p>Available on Site / Buy Now</p>
  </Fragment>
);

export default PostSaleTo;
